import type { JSX } from 'react';
import { Badge, Col, FormGroup, FormParagraph, Row } from '@ksyos/design-system';
import { round } from 'lodash';
import { TotalWeightLossState } from '@common/enums';
import { concatOrNull } from '@common/utils/textUtils';
import { NavigateToMonitoringTabLink } from '../../NavigateToMonitoringTabLink';

type BariPostTotalWeightLossFormGroupProps = Readonly<{
    totalWeightLoss: number;
    totalWeightLossState: TotalWeightLossState;
}>;

export function BariPostTotalWeightLossFormGroup(props: Readonly<BariPostTotalWeightLossFormGroupProps>): JSX.Element {
    const { totalWeightLoss, totalWeightLossState } = props;
    const { hasAlarm, alarmLabel } = getAlarmState(totalWeightLossState);

    return (
        <>
            <FormGroup
                label="Total weight loss"
                layout="horizontal"
            >
                <Row>
                    <Col span={1}>
                        <FormParagraph>{concatOrNull(round(totalWeightLoss, 2), '%')}</FormParagraph>
                    </Col>
                    <Col>
                        <Badge
                            color={hasAlarm ? 'orange' : 'green'}
                            icon={hasAlarm ? 'warning' : undefined}
                            text={alarmLabel}
                        />
                    </Col>
                </Row>
            </FormGroup>
            {hasAlarm && <NavigateToMonitoringTabLink />}
        </>
    );

    function getAlarmState(state: TotalWeightLossState) {
        if (
            [
                TotalWeightLossState.over75,
                TotalWeightLossState.overMedianPlus1SD,
                TotalWeightLossState.overMedianPlus2SD,
            ].includes(state)
        ) {
            return { alarmLabel: 'Te veel gewichtsverlies', hasAlarm: true };
        }
        if (
            [
                TotalWeightLossState.under25,
                TotalWeightLossState.underMedianMinus1SD,
                TotalWeightLossState.underMedianMinus2SD,
            ].includes(state)
        ) {
            return { alarmLabel: 'Te weinig gewichtsverlies', hasAlarm: true };
        }

        return { alarmLabel: 'Goed', hasAlarm: false };
    }
}
